import Axios from './axiosConfig';

import { ICreateQuote } from '../components/interfaces';
import { IAdminLogin } from '../constants/interfaces';
import { IQuoteMark } from './../constants/interfaces';

// public api
export const createQuoteApi = (data: ICreateQuote) => {
  return Axios.post(`/api/quote/create`, data);
};
// -------------------------------------------------------------------------------

// admin api
export const isLoggedInApi = () => Axios.get('/api/admin/isLoggedIn');

export const adminLoginApi = (data: IAdminLogin) =>
  Axios.post('/api/admin/login', data);

export const adminLogoutApi = () => Axios.get('/api/admin/logout');
// -------------------------------------------------------------------------------

// admin quote related api
export const getAllQuoteCountApi = () => Axios.get('/api/quote/count/all');

export const getAllQuote = (markAs: string, limit: number, skip: number) =>
  Axios.get(`/api/quote/all?markAs=${markAs}&limit=${limit}&skip=${skip}`);

export const quoteMarkApi = (data: IQuoteMark, id: string) =>
  Axios.put(`/api/quote/mark/${id}`, data);

export const deleteQuoteApi = (id: string) =>
  Axios.delete(`/api/quote/delete/${id}`);
